import { ComponentRoute } from '@/classes'

const ReceiptPaymentRoutes = {
  ReceiptPaymentView: new ComponentRoute('/receiptpayment/:AssetId', 'ReceiptPaymentView'),
  ReceiptPaymentDetail: new ComponentRoute('/receiptpayment/:AssetId', 'ReceiptPaymentDetail')
}

export default ReceiptPaymentRoutes